function setExpanded(promo, expanded, restoreFocus = false) {
  const content = promo.querySelector('[data-promo-content]');
  const toggle = promo.querySelector('[data-promo-toggle]');

  if (expanded) {
    const { top, height } = promo.getBoundingClientRect();
    promo.style.setProperty('--promo-top', `${top}px`);
    promo.style.setProperty('--promo-height', `${height}px`);
  }
  promo.toggleAttribute('data-open', expanded);
  content.inert = !expanded;
  toggle.setAttribute('aria-expanded', String(expanded));
  if (restoreFocus) toggle.focus();
}

function initialize(root) {
  root.querySelectorAll('[data-product-promo]:not([data-enhanced])').forEach((promo) => {
    setExpanded(promo, false);
    promo.setAttribute('data-enhanced', '');
  });
}

initialize(document);
document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) initialize(event.target);
});
document.addEventListener('variant:update', () => initialize(document));

function closeOutside(target) {
  document.querySelectorAll('[data-product-promo][data-open]').forEach((promo) => {
    if (!promo.contains(target)) setExpanded(promo, false);
  });
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  closeOutside(event.target);
  const promo = event.target.closest('[data-product-promo]');

  if (promo && event.target.closest('[data-promo-toggle]')) {
    setExpanded(promo, !promo.hasAttribute('data-open'));
  }
});

document.addEventListener('focusin', (event) => {
  if (event.target instanceof Element) closeOutside(event.target);
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const promo = document.querySelector('[data-product-promo][data-open]');
  if (promo) {
    event.preventDefault();
    setExpanded(promo, false, true);
  }
});
